module.exports = __webpack_public_path__ + "img/1STW-1MCB-1PW-1MC-2CB.b03089bf.svg";